import { ContentFileDto } from '@/api/contents';
import { PagedBox } from '@/types/squadrons';

export enum FileExportFormat {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export type ContentPreviewFile = {
  id?: number | null;
  url: string;
} | null;

export type ContentPreviewFileDto = ContentFileDto & {
  isError: boolean;
  isLoading: boolean;
  uploadProgress?: number | null;
  previewFile?: ContentPreviewFile;
  customPreviewFile?: ContentPreviewFile;
  renderedPdfFile?: ContentPreviewFile;
  isCustomizable?: boolean;
  quadrants?: PagedBox[];
  originalDimensions?:
    | { width: number; height: number; type: 'image' | 'pdf' | 'social-file' }
    | Record<
        number,
        { width: number; height: number; type: 'image' | 'pdf' | 'social-file' }
      >;
};
